import "./hero-section-leistungen.css";

type HeroImage = {
	src: string;
	alt: string;
	title?: string;
	ariaLabel?: string;
};

interface HeroSectionLeistungenProps {
	title: string;
	subtitle: string;
	image: HeroImage;
	sectionClassName?: string;
	containerClassName?: string; // if provided, wraps section in this container
}

export default function HeroSectionLeistungen(props: HeroSectionLeistungenProps) {
	const { title, subtitle, image, sectionClassName, containerClassName } = props;

	const section = (
		<section className={`hero-section${sectionClassName ? ` ${sectionClassName}` : ""}`}>
			<article className="hero-text">
				<h1 className="site-title-alone" dangerouslySetInnerHTML={{ __html: title }} />
				<h2 dangerouslySetInnerHTML={{ __html: subtitle }} />
			</article>
			<div className="hero-image">
				<img
					src={image.src}
					alt={image.alt}
					title={image.title}
					aria-label={image.ariaLabel}
				/>
			</div>
		</section>
	);

	if (containerClassName) {
		return <div className={containerClassName}>{section}</div>;
	}

	return section;
}
